const slideLength1 = document.querySelectorAll('.fv_slider .swiper-container .swiper-slide').length

if (slideLength1 > 1) {

const fv_slider = new Swiper('.fv_slider', {
    slidesPerView: 1,
    loop: true,
    centeredslides: true,
    spaceBetween: 0,
    autoplay: {
        delay: 2000,
    },
    speed: 1000,
    loopAdditionalSlides: 3,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
            slidesPerView: 1,
        }
    }

});

}else {
  $(".fv_slider").addClass("slideNone");
}

const recommend_slider = new Swiper('.recommend_slider', {
    slidesPerView: 1,
    loop: false,
    centeredslides: true,
    spaceBetween: 10,
    speed: 500,
    // slidesPerGroup: 1,
    // loopAdditionalSlides: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
            slidesPerView: 3,
            spaceBetween: 30,
            loop: false,
        }
    }

});
const slideLength2 = document.querySelectorAll('.recommend_slider .swiper-container .swiper-slide').length

if (slideLength2 > 4) {
} else {
  $(".recommend_slider").addClass("slideNone");
}

const tips_slider = new Swiper('.tips_slider', {
    slidesPerView: 1,
    loop: true,
    centeredslides: true,
    spaceBetween: 10,
    speed: 500,
    slidesPerGroup: 1,
    loopAdditionalSlides: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
            slidesPerView: 3,
            spaceBetween: 35,
            slidesPerGroup: 3,
            loopAdditionalSlides: 3,
        }
    }

});
const slideLength3 = document.querySelectorAll('.tips_slider .swiper-container .swiper-slide').length

if (slideLength3 > 4) {
} else {
  $(".tips_slider").addClass("slideNone");
}
function FixedAnime() {
    var headerH = $('.fv').outerHeight(true);
    var scroll = $(window).scrollTop();
    if (scroll >= headerH) {//headerの高さ以上になったら
        $('.aq_header').addClass('fixed');//fixedというクラス名を付与
    } else {//それ以外は
        $('.aq_header').removeClass('fixed');//fixedというクラス名を除去
    }
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
    FixedAnime();/* スクロール途中からヘッダーを出現させる関数を呼ぶ*/
});


function FixedAnime2() {
    var headerH = $('.fv').outerHeight(true);
    var scroll = $(window).scrollTop();
    if (scroll >= headerH && !$('.bnr_line').hasClass("active")) {//headerの高さ以上になったら
        $('.bnr_line').fadeIn();//fixedというクラス名を付与
    $   ('.bnr_line').addClass("active");//fixedというクラス名を付与
    } 
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
    FixedAnime2();/* スクロール途中からヘッダーを出現させる関数を呼ぶ*/
});


       const animBgParallax = () => {
            if (document.querySelector('.js-bg-parallax--target')) {
                const target = '.js-bg-parallax--target',
                    matchMedia = gsap.matchMedia(),
                    breakpoint = 768

                matchMedia.add({
                    isDesktop: `(min-width: ${breakpoint}px)`,
                    isMobile: `(max-width: ${breakpoint - 1}px)`,
                    reduceMotion: '(prefers-reduced-motion: reduce)'
                }, (context) => {
                    const { isDesktop, isMobile, reduceMotion } = context.conditions

                    gsap.utils.toArray(target).forEach((e) => {
                        gsap.fromTo(e, {
                            // filter: 'blur(12px)',
                            y: isMobile ? 60 : 80,
                        }, {
                            // filter: 'blur(0px)',
                            y: isMobile ? -60 : -80,
                            scrollTrigger: {
                                trigger: e,
                                start: 'top bottom',
                                end: 'bottom top',
                                scrub: isMobile ? 0.8 : 1.2,
                                // markers: true
                            }
                        })
                    })
                })
            }
        }
        animBgParallax();